import { useEffect, useState } from "react";
import {
  Spin,
  Card,
  Row,
  Col,
  Button,
  Drawer,
  Form,
  Input,
  Avatar,
  Typography,
  Upload,
  message,
  Divider,
} from "antd";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import { getProfile, updateProfile } from "../../ApiServices/Apifun";
import ApiService from "../../services/Axios";
import { APIURL } from "../../ApiServices/Axios";
const { Title, Text } = Typography;

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [form] = Form.useForm();

  const fetchProfile = () => {
    setIsLoading(true);
    getProfile()
      .then((response) => {
        if (response.status) {
          setProfile(response.data || {});
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching profile details:", err);
        setIsLoading(false);
      });
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleFormSubmit = (values) => {
 console.log(values);
    const formdata = new FormData();
    formdata.append("images", values.images.file)
    setIsLoading(true);
    updateProfile(formdata)
      .then((response) => {
        if (response.status) {
          message.success("Profile updated successfully");
          setProfile({ ...profile, ...values });
          fetchProfile();
          handleDrawerClose();
          setIsLoading(false);
        } else {
          message.error("Failed to update profile");
        }
      })
      .catch((err) => {
        console.error("Error updating profile:", err);
        message.error("An error occurred while updating the profile");
      }).finally(()=>{
        setIsLoading(false);
      })
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const cardStyle = {
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
    backgroundColor: "white",
  };

  const gradientBackground = {
    background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
    color: "#fff",
    padding: "50px 20px",
    textAlign: "center",
  };
console.log(APIURL);
  return (
    <>
      {isLoading ? (
        <div className="text-center mt-52">
          <Spin size="large" />
        </div>
      ) : profile ? (
        <>
          <div style={gradientBackground}>
            <Avatar
              size={120}
              // src={`${APIURL}/${profile.image_path}`  || "/default-avatar.png"}
               src={profile.imagePath || "/default-avatar.png"}
              style={{
                border: "4px solid white",
                marginBottom: "16px",
                backgroundColor: "#f56a00",
              }}
              alt="profile"
            />
            <Title level={2} style={{ color: "#fff", marginBottom: 0 }}>
              {profile.name}
            </Title>
            <Text style={{ color: "#f5f5f5", fontSize: "16px" }}>
              Role: {profile.role}
            </Text>
          </div>

          <Card style={{ ...cardStyle, margin: "20px auto", width: "90%" }}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <Text strong>Email:</Text>
                <p>{profile.email}</p>
              </Col>
              <Col xs={24} sm={12}>
                <Text strong>Mobile:</Text>
                <p>{profile.mobile_number}</p>
              </Col>
              <Col xs={24} sm={12}>
                <Text strong>Date of Birth:</Text>
                <p>{profile.dob || "Not provided"}</p>
              </Col>
              <Col xs={24} sm={12}>
                <Text strong>Role:</Text>
                <p>{profile.role}</p>
              </Col>
            </Row>

            <Divider />
            <Button
              type="primary"
              className="bg-rgbaprimary8"
              icon={<EditOutlined />}
              size="large"
              onClick={() => {
                form.setFieldsValue(profile);
                setIsDrawerOpen(true);
              }}
              block
            >
              Edit Profile
            </Button>
          </Card>

          <Drawer
            title="Edit Profile"
            width={400}
            onClose={handleDrawerClose}
            visible={isDrawerOpen}
            bodyStyle={{ paddingBottom: 80 }}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={handleFormSubmit}
              initialValues={profile}
            >
              {/* <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter your name" }]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>
              <Form.Item
                name="mobile_number"
                label="Mobile Number"
                rules={[
                  {
                    required: true,
                    message: "Please enter your mobile number",
                  },
                ]}
              >
                <Input placeholder="Enter your mobile number" />
              </Form.Item>
              <Form.Item name="dob" label="Date of Birth">
                <Input placeholder="Enter your date of birth" />
              </Form.Item> */}
              <Form.Item name="images" label="Profile Picture">
                <Upload
                  listType="picture"
                  maxCount={1}
                  beforeUpload={() => false}
                  accept="image/*"
                >
                  <Button icon={<UploadOutlined />}>Upload New Image</Button>
                </Upload>
              </Form.Item>
              <Button type="primary" disabled={isLoading} className="bg-rgbaprimary8" htmlType="submit" block>
                {isLoading ? "Updating..." : "Update Profile"}
              </Button>
            </Form>
          </Drawer>
        </>
      ) : (
        <p className="text-center">No profile data available</p>
      )}
    </>
  );
};

export default Profile;
